// extracted by mini-css-extract-plugin
export default {"filterTypeSelect":"styles_filterTypeSelect__ip5fU"};